
import { motion, AnimatePresence } from "framer-motion";
import Filter from "./Filter";
import { useState, useEffect } from "react";
// import skills from '../components/skills'
import filterIcon from "../assets/filter.svg";
import profilePic from "../assets/profilePic1.jpg";
import { Button } from "@mui/material/";

import { getDatabase, ref, onValue } from "firebase/database";

import { useParams, Link } from "react-router-dom";
import firebase from "../firebase";

import { blue } from "@mui/material/colors";

const Results = ({ handleHomeSearch, handleResultsSearch, toggleFilter, routeHome, setIsOpen, isOpen }) => {
  const [firedata, setFiredata] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const { personalID } = useParams();
  const [professionChoice, setProfessionChoice] = useState("all");
  const [mentorChoice, setMentorChoice] = useState("mentor");
  const [skillsChoice, setSkillsChoice] = useState([
    "Designer",
    "Product Manager",
    "Developer",
  ]);

  // STATE FOR BUTTON CLICK

  useEffect(() => {
    const database = getDatabase(firebase);
    const dbRef = ref(database);
    onValue(dbRef, (response) => {
      const newState = [];
      const data = response.val();

      for (let key in data) {
        // pushing the values from the object into our newState array
        newState.push({ personalID: key, data: data[key] });
      }
      const mentorResults = newState.filter(

        (item) => item.data.mentorType === "Mentor"
      );
      setFiredata(mentorResults);
      setFiltered(mentorResults);
    });
  }, []);
console.log(filtered);
  // const handleSkillsChoice F= (e, updatedskills) => {
  //   if (updatedskills !== null) {
  //     setSkillsChoice(updatedskills);
  //   }
    
  // };

  const handleProfessionChoice = (e, updatedprofession) => {
    if (updatedprofession !== null) {
      setProfessionChoice(updatedprofession);
    }
  };

  
  const handleFilterToggle = () => setIsOpen(!isOpen);

  const buttonSX = {
    backgroundColor: "#FFF",
    textTransform: "none",
    borderRadius: "16px",
    border: "3px solid #348F1B",
    fontWeight: "600",
    fontSize: "1.1rem",
    color: "#000",
    "&:hover": {
      backgroundColor: "#CEE1C9",
    },
  };


  return (
    <section className="resultsContainer wrapperResults">
      <h2>Mentors</h2>
      <Button 
        // className="filterButton" 
        onClick={handleFilterToggle}
        sx={buttonSX}
        className="button"
        variant="contained">
        <span className="filterIcon">
          <img src={filterIcon} alt="filter button icon" /> 
        </span>

        Filters
      </Button>
      <motion.div
        className="filterHide"
        animate={{
          height: isOpen ? "100%" : "0px",
          translateX: isOpen ? "0px" : "-1800px",
          transition: {
            duration: 1,
            type: "easeInOut",
            damping: 10,
          },
        }}
      >
        <Filter
          mentorChoice={mentorChoice}
          setMentorChoice={setMentorChoice}
          handleProfessionChoice={handleProfessionChoice}
          setProfessionChoice={setProfessionChoice}
          professionChoice={professionChoice}
          handleHomeSearch={handleHomeSearch}
          handleResultsSearch={handleResultsSearch}
          toggleFilter={toggleFilter}
          // handleSkillsChoice={handleSkillsChoice}
          setSkillsChoice={setSkillsChoice}
          skillsChoice={skillsChoice}
          firedata={firedata}
          setFiltered={setFiltered}
          filtered={filtered}
          handleFilterToggle={handleFilterToggle}
          displayClose={true}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          routeHome={false}
          // filterPosition={filterPosition}
          
          // setFiltered={() => {} }
        />
      </motion.div>
      <motion.div
        layout
        animate={{
          opacity: isOpen ? "1" : "1",
          transition: {
            duration: 1,
            type: "easeInOut",
            damping: 10,
          },
        }}
        exit={{ opacity: 0 }}
        transition={{ ease: "easeInOut", duration: 0.6 }}
        className="results"
      >
      {/* <h2>Mentors</h2> */}
      <ul>
        {filtered.map((profile, index) => {
          return (
            <motion.li
              key={index}
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              transition={{ ease: "easeInOut", duration: 1.6 }}
              layout
              className="profileCard"
            >
              {/* <Link to={`/personal/${profile.personalID}`}> */}
                {/* <p>{`${profile.data.name.firstName} ${profile.data.name.lastName}`}</p> */}
                {/* <p>{profile.data.profession}</p> */}
              <div className="resultsProfileImageContainer">
                <img src={profile.data.image[0].data_url} alt="" />
              </div>
                <span className="resultsProfileText">
                <h4>{`${profile.data.name.first} ${profile.data.name.last}`} <span className="pronouns">({profile.data.pronouns})</span></h4>
                <p>{profile.data.expertise}: {profile.data.expLevel} {profile.data.personality === "Introverted" && "Extroverted" ? (<p>{profile.data.personality}</p>) : null}</p>
                {/* <p> */}
                {/* {profile.data.personality === "Introverted" && "Extroverted" ? (<p>| {profile.data.personality}</p>) :null} */}

                {/* </p> */}
                  {/* <p>{profile.data.expLevel}</p> */}
                  {/* <p>{profile.data.skills}</p> */}

                </span>
              </motion.li>
            );
          })}
        </ul>
      </motion.div>
    </section>
  );
};

export default Results;
